import React, { useEffect, useState } from 'react';
import PaymentModal from './PaymentModal';
import UpgradePrompt from './UpgradePrompt';
import { subscribeToBillingEvents } from '../utils/billingEvents';

const BillingOverlayManager = () => {
	const [paymentDetail, setPaymentDetail] = useState(null);
	const [upgradeDetail, setUpgradeDetail] = useState(null);

	useEffect(() => subscribeToBillingEvents((detail) => {
		if (detail?.type === 'payment_required') {
			setPaymentDetail(detail);
			return;
		}
		if (detail?.type === 'plan_limit_reached') {
			setUpgradeDetail(detail);
		}
	}), []);

	return (
		<>
			<PaymentModal
				isOpen={Boolean(paymentDetail?.eventId)}
				eventId={paymentDetail?.eventId}
				initialAmountNgn={paymentDetail?.requiredAmountNgn || paymentDetail?.amountNgn || 0}
				onClose={() => setPaymentDetail(null)}
				onPaymentSuccess={() => setPaymentDetail(null)}
			/>
			<UpgradePrompt
				isOpen={Boolean(upgradeDetail)}
				detail={upgradeDetail}
				onClose={() => setUpgradeDetail(null)}
			/>
		</>
	);
};

export default BillingOverlayManager;
